import classNames from 'classnames'
import React from 'react'
import { GridLayoutProps } from './GridLayout.d'

const GridLayout = ({
  gap = 'md',
  column = 'default',
  classes,
  gapY,
  gapX,
  children
}: GridLayoutProps) => {
  const containerCss = classNames(classes, {
    'mx-auto': true
  })

  const gridContainerCss = classNames({
    'grid grid-cols-1': true,
    '!gap-y-0': gapY === 'none',
    '!gap-x-12': gapX === 'lg',
    'grid-cols-4 md:grid-cols-6 lg:grid-cols-12': column === 'default',
    'gap-0': gap === 'none',
    'gap-x-0 md:gap-x-7 gap-7': gap === 'md',
    'gap-x-0 md:gap-x-7 gap-4': gap === 'mds',
    'md:grid-cols-2': column === 'grid-cols-2',
    'md:grid-cols-3': column === 'grid-cols-3',
    'md:grid-cols-4': column === 'grid-cols-4',
    'md:grid-cols-5': column === 'grid-cols-5'
  })

  return (
    <div className={containerCss} data-testid='GridLayout'>
      <div className={gridContainerCss} data-testid='GridLayout-inner'>
        {children}
      </div>
    </div>
  )
}

export default GridLayout
